import { Injectable } from '@angular/core';
import { NewsGQL, NewsReactionInput, ReactOnNewsGQL } from '@cpd-app/generated';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NewsService {
  constructor(
    private newsGQL: NewsGQL,
    private reactOnNewsGQL: ReactOnNewsGQL
  ) {}

  public getNews() {
    return this.newsGQL.fetch().pipe(map((result) => result.data));
  }

  public reactOnNews(isHepfulInput: NewsReactionInput) {
    return this.reactOnNewsGQL
      .mutate({
        input: isHepfulInput
      })
      .pipe(map((result) => result.data.reactOnNews));
  }
}
